import { useState } from "react";
import { Button, Input } from "@heroui/react";
import { useShallow } from "zustand/shallow";
import { FunnelSimpleIcon, MagnifyingGlassIcon } from "@phosphor-icons/react";

import { useBoundStore } from "@/app/store";
import { Drawer } from "@/shared/components/common/Drawer";
import { TagsList } from "@/features/tags/components/TagsList";

interface NotesTagsFilterDrawerProps {
  selectedTags?: string[];
  onTagsChange?: (selectedTags: string[]) => void;
}

export function NotesTagsFilterDrawer({ selectedTags = [], onTagsChange }: NotesTagsFilterDrawerProps) {
  const [filterText, setFilterText] = useState("");

  const { tags } = useBoundStore(
    useShallow((state) => ({
      tags: state.tags.list,
    }))
  );

  const handleTagsChange = (newSelectedTags: string[]) => {
    if (onTagsChange) {
      onTagsChange(newSelectedTags);
    }
  };

  const handleClearAll = () => {
    if (onTagsChange) {
      onTagsChange([]);
    }
  };

  return (
    <Drawer id="notes-tags-filter" icon={<FunnelSimpleIcon />}>
      <div className="w-full">
        <div className="mb-4 flex items-center gap-2">
          <Input
            placeholder="Search tags..."
            value={filterText}
            onValueChange={setFilterText}
            startContent={<MagnifyingGlassIcon size={16} />}
            className="flex-1"
            isClearable
            onClear={() => setFilterText("")}
          />

          {selectedTags.length > 0 && (
            <Button variant="flat" color="default" onPress={handleClearAll}>
              Clear all ({selectedTags.length})
            </Button>
          )}
        </div>

        <div className="max-h-56 pt-2">
          <TagsList
            tags={tags}
            selectedTags={selectedTags}
            onCheckboxChange={handleTagsChange}
            filterText={filterText}
          />
        </div>
      </div>
    </Drawer>
  );
}
